import {
  EApiDatafanPipelineStatus,
  EApiDatafanPipelineType,
  EApiDatafanStreamReportStatus,
  EApiDatafanStreamStatus,
  IApiDatafanPipeline,
} from "@smp/api";

import { useQueryDatafanPipelineTypes } from "@/queries/datafan";

export type IPipelineDataStatus =
  | "ready_partly"
  | "ready"
  | "error"
  | "in_progress"
  | "in_progress_first_run"
  | "archived";

const IS_FAST_RUN_DISABLED = true;

export const useDatafanPipelineDataStatus = () => {
  const { data: pipelineTypes } = useQueryDatafanPipelineTypes();

  return (pipeline: IApiDatafanPipeline): IPipelineDataStatus => {
    const isPipelineSupportFastRun =
      pipelineTypes?.[pipeline.source]?.enable_fast_run;

    if (pipeline.status === EApiDatafanPipelineStatus.ARCHIVED) {
      return "archived";
    }

    const streams = [
      EApiDatafanPipelineType.MERGE,
      EApiDatafanPipelineType.MERGE_PLAN_FACT,
    ].includes(pipeline.source)
      ? pipeline.streams_merge || []
      : pipeline.streams;

    if (
      [
        EApiDatafanPipelineType.MERGE,
        EApiDatafanPipelineType.MERGE_PLAN_FACT,
      ].includes(pipeline.source)
    ) {
      if (
        pipeline.report_status.some(
          ({ status }) => status !== EApiDatafanStreamReportStatus.SUCCESS,
        ) &&
        pipeline.is_first_run
      ) {
        return "in_progress_first_run";
      }

      return "ready";
    }

    if (
      [
        EApiDatafanPipelineStatus.CREDENTIAL_LOST,
        EApiDatafanPipelineStatus.ARCHIVED,
        EApiDatafanPipelineStatus.DELETED,
      ].includes(pipeline.status) ||
      streams.some(
        ({ status }) =>
          status !== null &&
          [
            EApiDatafanStreamStatus.CREDENTIAL_LOST,
            EApiDatafanStreamStatus.CREDENTIAL_NOT_PERMISSION,
            EApiDatafanStreamStatus.CREDENTIAL_NOT_ACCOUNT_PERMISSION,
            EApiDatafanStreamStatus.CREDENTIAL_LOST_SHARED,
          ].includes(status),
      ) ||
      pipeline.report_status.some(
        (rs) =>
          rs.status !== EApiDatafanStreamReportStatus.SUCCESS &&
          rs.retry_count >= 5,
      )
    ) {
      return "error";
    }

    if (
      pipeline.report_status.some(
        ({ status }) => status !== EApiDatafanStreamReportStatus.SUCCESS,
      )
    ) {
      if (
        !IS_FAST_RUN_DISABLED &&
        isPipelineSupportFastRun &&
        pipeline.is_first_run &&
        !streams.some(({ escaping_fast_already }) => !escaping_fast_already)
      ) {
        return "ready_partly";
      }

      if (pipeline.is_first_run) {
        return "in_progress_first_run";
      }

      return "in_progress";
    }

    return "ready";
  };
};
